/*----------------------
   COLLECTIONS FILTERS
---------------------- */
CollectionsFilter = {
    init: function () {
        function getActiveSpace() {
            var $activeFilter = $('.collections-page__filter-link-space.active').first();
            return $activeFilter.length ? String($activeFilter.attr('data-space-filter')) : '';
        }

        function productMatchesFilter($product, activeSpace) {
            if (!activeSpace) return true;

            var productSpaces = String($product.attr('data-space-values') || '')
                .split('|')
                .filter(Boolean);

            return $.inArray(activeSpace, productSpaces) !== -1;
        }

        function applySpaceFilter() {
            var activeSpace = getActiveSpace();

            $('.collection-item').each(function () {
                var $collection = $(this);
                var visibleProducts = 0;

                $collection.find('.collection-item__product').each(function () {
                    var $product = $(this);
                    var matches = productMatchesFilter($product, activeSpace);

                    if (matches) {
                        $product.css('display', '');
                        visibleProducts++;
                    } else {
                        $product.css('display', 'none');
                    }
                });

                if (visibleProducts === 0) {
                    $collection.css('display', 'none');
                } else {
                    $collection.css('display', '');
                }
            });
        }

        function scrollToFiltersWrapper() {
            var $target = $('#trigger-filter');
            if (!$target.length) return;

            $('html, body').stop(true).animate(
                {
                    scrollTop: $target.offset().top
                },
                500
            );
        }

        $(document).off('click.collectionsFilter').on('click.collectionsFilter', '.collections-page__filter-link-space', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $clicked = $(this);
            var isAlreadyActive = $clicked.hasClass('active');

            $('.collections-page__filter-link-space').removeClass('active');

            if (!isAlreadyActive) {
                $clicked.addClass('active');
            }

            applySpaceFilter();
            scrollToFiltersWrapper();
        });
    }
};

$(document).ready(function () {
    CollectionsFilter.init();
});